import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/aws/v1/s3`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const downloadObjectS3 = async ({ empresa_cnpj, body, empresa_id }) => {
  return search(
    `${path}/downloadobject?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}`,
    "POST",
    headers,
    body
  );
};
